import axios from 'axios'
import Config from '@enlyt/helpers/env'
import _ from 'lodash'

import { findViewableDocument } from 'api/api'

const filterCurrentDocuments = bundle => ({
  ...bundle,
  entry: _.filter(
    _.get(bundle, 'entry', []),
    item => _.get(item, 'resource.status', '') === 'current'
  )
})

export const fetchInitialViewableDocumentsPage = async ({
  patientId,
  encounter
}) => {
  const bundle = await findViewableDocument({ patientId, encounter })
  return filterCurrentDocuments(bundle)
}

export const fetchNextViewableDocumentsPage = async ({ nextUrl, token }) => {
  const encodedNextUrl = encodeURIComponent(nextUrl)
  const client = axios.create({
    baseURL: `${Config.EH_CLOUD_API_URL}fhir/auth0`,
    method: 'get',
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
  const result = await client.request(
    `DocumentReference?next=${encodedNextUrl}`
  )
  return filterCurrentDocuments(result?.data)
}
